<template>
	<div>
	  <div class="asd-margin" style="margin-top: 0px;">
		<el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 10px;">
		  <el-breadcrumb-item :to="{ path: '/admin/zonglan' }">智慧残联</el-breadcrumb-item>
		  <el-breadcrumb-item :to="{ path: '/admin/kangfu' }">康复救助全场景</el-breadcrumb-item>
		  <el-breadcrumb-item :to="{ path: '/admin/kangfu' }">{{type}}</el-breadcrumb-item>
		  <el-breadcrumb-item>
			<span>{{thisyear}}</span>年度
			<el-dropdown @command="handleCommand">
			  <el-button style="margin:0 0 0 0;padding: 0 0 0 0;" type="text">切换年度</el-button>
			  <el-dropdown-menu slot="dropdown">
				<el-dropdown-item :command="p" v-for="(p,i) in years">{{p}}</el-dropdown-item>
			  </el-dropdown-menu>
			</el-dropdown>
		  </el-breadcrumb-item>
		</el-breadcrumb>
	  </div>
	  <el-row :gutter="20">
		<el-col :span="22">
		  <adminkf1 :year="Number.parseInt(thisyear)" v-if="type=='救助情况概览'"></adminkf1>
		  <adminkf2 v-if="type=='康复儿童名单'"></adminkf2>
		  <!-- <adminkf3 v-if="type=='定点机构管理'"></adminkf3> -->
		  <adminkf4 v-if="type=='资金结算管理'"></adminkf4>
		  <adminkf5 :year="Number.parseInt(thisyear)" v-if="type=='机构运行预警'"></adminkf5>
		</el-col>
		<el-col :span="2" style="display: flex;flex-direction: column;align-items: center;">
		  <div>
			<el-button @click="changeT('救助情况概览')" autofocus class="etbutton">救助情况概览</el-button>
			<el-button @click="changeT('康复儿童名单')" autofocus class="etbutton">康复儿童名单</el-button>
			<!-- <el-button @click="changeT('定点机构管理')" autofocus class="etbutton">定点机构管理</el-button> -->
			<el-button @click="changeT('资金结算管理')" autofocus class="etbutton">资金结算管理</el-button>
			<el-button @click="changeT('机构运行预警')" autofocus class="etbutton">机构运行预警</el-button>
		  </div>
  
		</el-col>
	  </el-row>
	</div>
  </template>
  
  <script>
	import adminkf1 from "../../src/components/admins/adminkf1.vue"
	import adminkf2 from "../../src/components/admins/adminkf2.vue"
	// import adminkf3 from "../../src/components/admins/adminkf3.vue"
	import adminkf4 from "../../src/components/admins/adminkf4.vue"
	import adminkf5 from "../../src/components/admins/adminkf5.vue"
	export default {
	  data() {
		return {
		  page: 0,
		  size: 10,
		  lists: [],
		  years: [],
		  count: 0,
		  thisyear: new Date().getFullYear(),
		  dialogVisible: false,
		  type: "救助情况概览"
		}
	  },
	  components: {
		adminkf1,
		adminkf2,
		// adminkf3,
		adminkf4,
		adminkf5
	  },
	  computed: {
		info() {
		  let info = window.localStorage.getItem("info");
		  return JSON.parse(info);
		}
	  },
	  methods: {
		changeT(tp) {
		  this.type = tp;
		},
		getFormatDate(date) {
		  var date = new Date(date);
		  var seperator1 = "-";
		  var seperator2 = ":";
		  var month = date.getMonth() + 1;
		  var strDate = date.getDate();
		  if (month >= 1 && month <= 9) {
			month = "0" + month;
		  }
		  if (strDate >= 0 && strDate <= 9) {
			strDate = "0" + strDate;
		  }
		  var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
			" " + (date.getHours() < 10 ? "0" : "") + date.getHours() + seperator2 + (date.getMinutes() < 10 ?
			  "0" :
			  "") + date.getMinutes() +
			seperator2 + (date.getSeconds() < 10 ? "0" : "") + date.getSeconds();
		  return currentdate;
		},
		handleCommand(command) {
			console.log(command);
			this.thisyear = command;
		},
		getyears() {
		  let endyear = new Date().getFullYear();
		  for (var i = endyear; i >= 2021; i--) {
			this.years.push(i);
		  };
		  this.thisyear = endyear;
		},
		ConvertToObj(obj) {
		  for (var p in obj) {
			var content = obj[p];
			if (typeof(content) === "string" && content.substr(0, 1) === "[" && content.substr(-1, 1) === "]") {
			  obj[p] = JSON.parse(content);
			};
			if (typeof(content) === "string" && content.substr(0, 1) === "{" && content.substr(-1, 1) === "}") {
			  obj[p] = JSON.parse(content);
			};
		  };
		  return obj;
		}
	  },
	  async created() {
		this.getyears();
	  }
	}
  </script>
  
  <style>
	.fdir {
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	}
  
	.etbutton {
	  margin-top: 20px;
	  margin-left: 0px !important;
	}
  </style>